export default "__VITE_ASSET__L7n$klK8__"